import React from "react"
import { get, isEmpty } from 'lodash'
import { PlayCircleSvg } from '~/components/VideoPlayer/assets/icons.js'
import { trackEvent } from "~/tools/analytics/cleverTap";
import { getUser } from "~/redux/user/helpers";
import { formatStartTime } from "~/tools/date-utils";
import popup from "~/views/Popup/popup";
import { addToCalendar } from "~/tools/addToCalendar";
import {
	getVideoInfo,
	addToQueue,
	removeFromQueue
} from "~/redux/uservideo/helpers";
import Timer from "~/components/Timer/timer-svg";
import {Bookmark, CalendarIcon} from "~/assets/svg";
import './styles.scss'

class ListItemDetailed extends React.Component {
	constructor(props){
		super(props)
		this.state = {
			topOffset: 0,
			isLive: false,
			hoverOverflow: false,
			isQueued: false
		}
		this.handleResize = this.handleResize.bind(this)
		this.itemGist = this.props.isFollowingModule ? (this.props.item.contentDetails.gist) : (this.props.item.gist || this.props.item)
		this.item = this.props.isFollowingModule ? this.props.item.contentDetails : this.props.item
	}
	componentDidMount(){
		this.handleResize()
		this.fetchUserData();
		window.addEventListener('resize', this.handleResize)
	}
	componentWillUnmount() {
		window.removeEventListener('resize', this.handleResize);
	}
	handleResize(){
		if (window.innerWidth < 600) {
			this.setState({
				topOffset: 160,
				deviceType: 'mobile'
			})
		} else if ((window.innerWidth > 600 && window.innerWidth < 1025)) {
			this.setState({
				topOffset: 130,
				deviceType: 'tablet'
			})
		} else {
			this.setState({
				topOffset: 116,
				deviceType: 'desktop'
			})
		}
	}
	handleFocus = e => {
		e.persist();
		setTimeout(() => {
			e.currentTarget.focus();
			this.props.onFocus(this.props.index);
		}, 500);
	}
	fetchUserData() {
		var id = this.itemGist.id;
		getUser(user => {
			if (!user) {
				this.setState({ userData: null });
				return;
			}
			getVideoInfo(id, data => {
				this.setState({ userData: data, isQueued: data.isQueued });
			});
		});
	}
	addToQueue = () => {
		const gist = this.itemGist
		const id = gist.id
		const contentType = gist.contentType
		this.setState({ isQueued: null })

		addToQueue(id, contentType, data => {
			var addToQueueEventData = {
				contentId: gist.id,
				contentTitle: gist.title,
				contentType: gist.contentType,
				contentDuration: gist.runtime,
				playbackType: "Streamed",
				networkType: "WiFi"
			}
			trackEvent("Added to Watchlist", addToQueueEventData)
			this.setState({ isQueued: true })
		})
	}
	removeFromQueue = () => {
		const gist = this.itemGist
		const id = gist.id
		this.setState({ isQueued: null })

		removeFromQueue(id, data => {
			var removeFromQueueEventData = {
				contentId: gist.id,
				contentTitle: gist.title,
				contentType: gist.contentType,
				contentDuration: gist.runtime,
				playbackType: "Streamed",
				networkType: "WiFi"
			}
			trackEvent("Removed From Watchlist", removeFromQueueEventData)
			this.setState({ isQueued: false })
		})
	}
	checkLive = () => {
		if(this.props.onLive) this.props.onLive(this.itemGist.id)
		this.setState({ isLive: true })
	}
	renderTimer = () => {
		let {
			scheduleStartDate: startTimestamp,
			scheduleEndDate: endTimestamp
		} = this.itemGist;
		const formattedStartTime = formatStartTime(startTimestamp);
		if (startTimestamp - Date.now() > 60 * 60 * 1000) {
			return <span>{formattedStartTime}</span>
		}
		return (
			<div className={`LiveEvent_starttime ${this.state.isLive ? 'live' : ''}`}>
				{ this.state.isLive && <span>{formattedStartTime}</span> }
				<Timer
					scheduleStartDate={startTimestamp}
					scheduleEndDate={endTimestamp}
					displayDetailedTime={true}
					shortForm={true}
					checkLive={this.checkLive}
				/>
			</div>
		)
	}
	renderSignUpView = ({ closePopup  }) => {
	return (<div className="signup-container">
			<div className="container-heading">Create an account to Bookmark this class</div>
			<div className="container-content">Unlock achievements, download and bookmark content and more by creating an account!</div>
			<div className="container-buttons">
				<span onClick={() => {closePopup()}}>Cancel</span>
				<span onClick={() => popup.fitnessSignInCreate({showCloseButton: false})}>Sign Up Now</span>
			</div>
		</div>)
	}
	showSignUpAlert = () => {
		popup.customOverlay({
			renderContent: d => this.renderSignUpView(d),
			showCloseButton: false
		});
		
	}
	render(){
		const gist = this.itemGist
		const {images, tags} = this.item
		const bgImage = gist.videoImageUrl || get(gist.videoImage, 'url') || get(gist, 'landscapeImageUrl') || get(images, '_16x9Image.secureUrl') || get(gist, 'imageGist["_16x9"]')  || get(window.settings, 'images.placeholderCover')
		const duration = tags.find(t => t.tagType === "classDuration") || {}
		// const metaData = tags.find(t => t.tagType === null)
		const conceptTitle = this.props.conceptTitle || (get(this.props.item.gist, 'featuredTag.title', ''));
		const author = !isEmpty(gist.persons) ? gist.persons[0].title : "";
		const hideAuthor = this.props.hideAuthor;
		const classesList = get(this.item, 'contentDetails.seasons', null);
		const itemThumbnailCSS = {
			backgroundImage: `url(${bgImage}?impolicy=resize&w=216&h=122)`,
			backgroundSize: "cover",
			backgroundRepeat: "no-repeat",
			backgroundPosition: "center top"
		}
		return (
			<div className={`item-data`} onMouseEnter={this.handleHover}>
				<a href={`${gist.permalink}`} className={`item-thumbnail`} style={itemThumbnailCSS}>
					{
						this.props.showPlayIcon &&
						<PlayCircleSvg />
					}
				</a>
				<div className={`item-info`}>
					<div className={`item-runtime`}>
						{duration.title && (<span className="duration">{`${duration.title.replace(" min", "M")}`}<i className="icon ion-record"></i></span>)}
						{!isEmpty(gist.primaryCategory) && (<span className="category">{`  ${gist.primaryCategory.title}`}</span>)}
					</div>
					<a href={`${gist.permalink}`} className={`item-title`}>
						{gist.title}
					</a>
					<div className={`item-meta-data`}>
					{ !hideAuthor && author && `${conceptTitle}${' with ' + author}`}
					{ classesList && classesList.length > 0 && `${classesList.length} classe(s) available`}
					</div>
					{this.props.showBookmark ? (this.state.userData ?
							(<span className={`bookmark-icon ${this.state.isQueued ? 'bookmarked' : ''}`} onClick={this.state.isQueued ? this.removeFromQueue : this.addToQueue}>
								<Bookmark />
							</span>)
							:
							(
								<span className={`bookmark-icon`} onClick={this.showSignUpAlert.bind(this)}>
									<Bookmark />
								</span>
							)
					): null}
					{this.props.showChevron && (<a className='item-link' href={`${gist.permalink}`}><ion className="ion-chevron-right"></ion></a>)}
				</div>
				{(this.props.showTimer || this.props.addToCalender) && (<div className="item-time">
					{
						this.props.showTimer && this.renderTimer()
					}
					{
						this.props.addToCalender && !this.state.isLive && ( <i onClick={() => addToCalendar(gist)}><CalendarIcon/></i> )
					}
				</div>)}
			</div>
		)
	}
}

export default ListItemDetailed;